export default __webpack_public_path__ + "static/media/NitinGupta-new.f877383d.png";